<template>
  <div class="min-w-max">
    <section class="flex justify-between px-10 py-3">
      <ul class="flex items-center">
        <li class="pr-6">
          <a href="#" @click.prevent="changePage(prevPage)">
            <div class="flex items-center justify-center h-6 w-6">
              <p class="text-sm text-brand-black">Prev</p>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasFirst()">
          <a href="#" @click.prevent="changePage(1)" class="group">
            <div
              class="flex group-hover:bg-brand-green rounded h-6 w-6 items-center justify-center"
            >
              <span class="text-brand-black"> 1 </span>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasFirst()">...</li>
        <li class="pr-6" v-for="(page, index) in pages" :key="index">
          <a href="#" @click.prevent="changePage(page)" class="group">
            <div
              :class="[
                current == page
                  ? 'bg-brand-green'
                  : 'box-content border-2 border-brand-background-light-blue bg-white group-hover:bg-brand-background-blue-gray'
              ]"
              class="flex h-6 w-6 rounded items-center justify-center"
            >
              <span :class="[current == page ? 'text-white' : 'text-brand-black']">{{ page }}</span>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasLast()">...</li>
        <li class="pr-6" v-if="hasLast()">
          <a href="#" @click.prevent="changePage(totalPages)" class="group">
            <div class="px-1 flex rounded items-center justify-center group-hover:bg-brand-green">
              <p class="text-brand-black group-hover:text-white">
                {{ totalPages }}
              </p>
            </div>
          </a>
        </li>
        <li class="pr-6">
          <a href="#" @click.prevent="changePage(nextPage)">
            <div class="flex items-center justify-center h-6 w-6">
              <p class="text-sm text-brand-black">Next</p>
            </div>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
// From https://github.com/OCRVblockchain/vue-tailwind-pagination
export default {
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 25
    },
    pageRange: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      input: ""
    }
  },
  methods: {
    hasFirst: function () {
      return this.rangeStart !== 1
    },
    hasLast: function () {
      return this.rangeEnd < this.totalPages
    },
    hasPrev: function () {
      return this.current > 1
    },
    hasNext: function () {
      return this.current < this.totalPages
    },
    changePage: function (page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit("page-changed", page)
      }
    }
  },
  computed: {
    pages: function () {
      var pages = []
      for (var i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i)
      }
      return pages
    },
    rangeStart: function () {
      var start = this.current - this.pageRange
      return start > 0 ? start : 1
    },
    rangeEnd: function () {
      var end = this.current + this.pageRange
      return end < this.totalPages ? end : this.totalPages
    },
    totalPages: function () {
      return Math.ceil(this.total / this.perPage)
    },
    nextPage: function () {
      return this.current + 1
    },
    prevPage: function () {
      return this.current - 1
    }
  }
}
</script>
